<div #filterBox>
  <mat-form-field class="filter-box no-subscript pt-1">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [formControl]="filterCtrl"
      placeholder="Text to filter"
      [ngClass]="{
        'negative-filter': isNegativeFilter(filterCtrl.value ?? '')
      }"
    />
    <mat-icon
      *ngIf="!valueFilter"
      class="filter-icon"
      color="primary"
      (click)="applyFilter($event)"
      >search</mat-icon
    >
    <mat-icon
      *ngIf="valueFilter"
      class="filter-icon pointer"
      color="warn"
      (click)="applyFilter(null)"
      >close</mat-icon
    >
  </mat-form-field>
</div>
<div
  class="results border py-2 white-background"
  [ngClass]="{ invisible: !filteredValues?.length }"
  #results
>
  <div
    class="item row px-2 py-1"
    *ngFor="let item of filteredValues"
    (click)="itemSelected(item)"
  >
    <div class="col">
      <span
        class="item-content"
        [innerHTML]="item.text | highlightSearch : valueFilter"
      ></span>
    </div>
  </div>
</div>
